import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const STORAGE_PREFIX = "nova_admin_seen_count_";

const RESOURCES = [
  { key: "demo_requests", path: "/admin/demo-requests", endpoint: "/admin/demo-requests", countFrom: (data) => (data.demo_requests || []).length },
  { key: "organizations", path: "/admin/organizations", endpoint: "/admin/organizations", countFrom: (data) => (data.organizations || []).length },
  { key: "quotes", path: "/admin/quotes", endpoint: "/admin/quotes", countFrom: (data) => (data.quotes || []).length },
];

export const useNewItemBadges = (API) => {
  const location = useLocation();
  const [badges, setBadges] = useState({});
  const seenRef = useRef({});
  const countsRef = useRef({});

  const recompute = useCallback(() => {
    const next = {};
    RESOURCES.forEach((r) => {
      const seen = seenRef.current[r.key];
      const count = countsRef.current[r.key];
      next[r.key] = seen != null && count != null ? Math.max(0, count - seen) : 0;
    });
    setBadges(next);
  }, []);

  const check = useCallback(async () => {
    await Promise.all(RESOURCES.map(async (r) => {
      try {
        const { data } = await axios.get(`${API}${r.endpoint}`, { withCredentials: true });
        const count = r.countFrom(data);
        countsRef.current[r.key] = count;
        if (seenRef.current[r.key] == null) {
          const stored = window.localStorage.getItem(STORAGE_PREFIX + r.key);
          if (stored !== null) {
            seenRef.current[r.key] = parseInt(stored, 10);
          } else {
            seenRef.current[r.key] = count;
            window.localStorage.setItem(STORAGE_PREFIX + r.key, String(count));
          }
        }
      } catch {
        /* ignore transient badge polling failures */
      }
    }));
    recompute();
  }, [API, recompute]);

  useEffect(() => {
    check();
    const id = window.setInterval(check, 10000);
    return () => window.clearInterval(id);
  }, [check]);

  useEffect(() => {
    RESOURCES.forEach((r) => {
      if (location.pathname.startsWith(r.path) && countsRef.current[r.key] != null) {
        seenRef.current[r.key] = countsRef.current[r.key];
        window.localStorage.setItem(STORAGE_PREFIX + r.key, String(countsRef.current[r.key]));
      }
    });
    recompute();
  }, [location.pathname, recompute]);

  return badges;
};
